const material = {
    state: {

        list: []
      },

      mutations: {
        SET_LIST: (state, list) => {
            state.list = list
        },
      },

      actions: {
        setList({ commit, state }, list) {
            return new Promise((resolve) => {
              commit('SET_LIST', list)
            })
          },


        //   toggleDevice({ commit,state }, list) {
        //     commit('SET_LIST', list)
        //   },

      }

}
export default material


// WEBPACK FOOTER //
// ./src/store/modules/material.js